import * as React from "react";
import { preventEvent } from "../../core/utils/handleEvents";
import { APINames } from "../../legacy/api/api.names";
import { IButtonEvents } from "../_common/buttonEvents";
import { Icon } from "../IconSVG";
import { Wrapper } from "./components/Wrapper";

export interface IAutoplayButton extends IButtonEvents {
  onClick?: React.EventHandler<React.MouseEvent>;
  disabled?: boolean;
  autoplayRoundsLeft?: number;
  autoplayRunning?: boolean;
  useSmallIcon?: boolean;
}

export type AutoplayButtonEvents =
  | "autoplaystopbutton.click"
  | "autoplaystopbutton.disabled"
  | "autoplaystopbutton.value"
  | "autoplaystopbutton.enter"
  | "autoplaystopbutton.leave"
  | "autoplaystartbutton.click"
  | "autoplaystartbutton.disabled"
  | "autoplaystartbutton.value"
  | "autoplaystartbutton.enter"
  | "autoplaystartbutton.leave";

export const AutoplayButton = ({
  autoplayRunning,
  autoplayRoundsLeft,
  ...props
}: IAutoplayButton) => {
  const icon = autoplayRunning
    ? props.useSmallIcon
      ? "stop-small"
      : "stop"
    : "play";
  const apiName = autoplayRunning
    ? APINames.AUTOPLAY_STOP_BUTTON
    : APINames.AUTOPLAY_START_BUTTON;
  return (
    <Wrapper
      apiName={apiName}
      data-rounds-left={autoplayRoundsLeft}
      autoplayRoundsLeft={autoplayRoundsLeft}
      autoplayRunning={autoplayRunning}
      onDragStart={preventEvent}
      {...props}
    >
      <Icon type={icon} />
      <p>{autoplayRoundsLeft}</p>
    </Wrapper>
  );
};
